import CardHeaderBG from "../../components/components-library/card-header-bg";
import SearchBox from "../../components/components-library/searchbox";
import { useDispatch } from "react-redux";
import { Button, PanelSlider, TabsList } from "../../components/ui";
import { Add, RefreshSharp } from "@mui/icons-material";
import { useState } from "react";
import ParameterCustomAccordion from "./custom-accordian-parameters";
import Modal from "../../components/ui/modal";
import ModalHeader from "../../components/ui/modal/modal-header";
import DeleteParameter from "./delete-parameter";
import ModalFooter from "../../components/ui/modal/modal-footer";
import deleteicon from "../../assets/images/delete_icon.svg";
import AddParameter from "./add-parameter/add-parameter";
import useGetParametersRules from "./useGetParametersRules";
import cancelIcon from "../../assets/images/close.svg";
import RulesSection from "./add-rule/add-rule";
import { useNavigate } from "react-router-dom";
import {
  resetParametersDetails,
  setActiveCategoryTab,
  setDeletedParameterId,
  setParameterMode,
  setRefreshParametrsEntity,
  setSelectedParameter,
} from "../../reducers/riskEngineSlice";
import Nodata from "../customersV2/customerDetails/Nodata";
import AddRuleParams from "./add-rule/add-rule-params";
const RiskEngine = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    onClickAddParameter,
    addParameterPanelStatus,
    onClickAddRule,
    addRulePanelStatus,
    activeCategoryTab,
    filteredParametersData,
    setSearchtext,
    searchText,
    deletedParametrId,
    deleteParameterModal,
    setDeleteParameterModel,
    setDeleteRuleModel,
    deleteRuleModal,
    addEditParameterMode,
    setAdjustedParams,
    deleteParameterFun,
    adjustedParams,
    onAddRules,
    setAllParamsRefresh,
    allParamsRefresh,
    ruleMode,
  } = useGetParametersRules();
  const onClickEditParameter = (parameter: any) => {
    dispatch(setParameterMode("EDIT"));
    dispatch(setSelectedParameter(parameter));

    onClickAddParameter(true);
  };
  const onClickDeleteParameter = (parameter: any) => {
    dispatch(setParameterMode("DELETE"));
    dispatch(setSelectedParameter(parameter));

    onClickAddParameter(true);
  };
  const DeleteParameter = (id: number) => {
    setDeleteParameterModel(true);
    dispatch(setDeletedParameterId(id));
  };
  const DeleteRuleOnClick = () => {
    setDeleteRuleModel(true);
  };

  return (
    <>
      {" "}
      <div className="outlet_padding">
        <CardHeaderBG
          titile="Parameters and Rules"
          titileClassName="bg-oceangreen "
        >
          <div className="card_space_18">
            {" "}
            <div className="flex justify-between ">
              <div className="w-50">
                <SearchBox
                  className="w-full"
                  value={searchText}
                  onChange={(e) => {
                    setSearchtext(e.target.value);
                  }}
                  placeholder="Search by Parameter"
                />
              </div>
              <div className="flex gap-4 items-center">
                <Button
                  className=""
                  variant="outlined-primary"
                  onClick={() => {
                    navigate("/risk-engine/composition");
                  }}
                >
                  <div className="flex gap-2 items-center">Composition</div>
                </Button>
                <Button
                  className=""
                  variant="contained"
                  onClick={() => {
                    onClickAddParameter(true);
                    dispatch(resetParametersDetails());
                    dispatch(setParameterMode("ADD"));
                  }}
                >
                  <div className="flex gap-2 items-center">
                    <Add className="color-white" /> Add Parameter
                  </div>
                </Button>
              </div>
            </div>
            <div className="space_18 flex flex-1 overflow-hidden justify-between items-center border-b">
              <TabsList
                data={[
                  {
                    label: `FINANCIAL`,
                    value: "FIN",
                  },
                  {
                    label: `TRANSACTION `,
                    value: "TXN",
                  },
                  { label: "AMID", value: "AMID" },
                  { label: "CREDIT SCORE", value: "CREDIT" },
                ]}
                activeTab={activeCategoryTab}
                onChange={(tab, i) => {
                  dispatch(setActiveCategoryTab(tab.value));
                }}
                className=""
              />
              <div
                className="flex items-center cursor-pointer color-primary border-primary px-3 py-1 rounded-full"
                onClick={() => {
                  dispatch(setRefreshParametrsEntity());
                  setAllParamsRefresh(true);
                  setSearchtext("");
                }}
                style={{ background: "#EBFFF0" }}
              >
                <RefreshSharp
                  className={`${allParamsRefresh ? "animate-spin" : ""} mr-1`}
                />
                <span className="fs-14 color-primary font-semibold">
                  Refresh
                </span>
              </div>
            </div>
            <div
              className="space_18 overflow-y-auto"
              id="scroll_style"
              style={{ height: "calc(100vh - 18.5rem)" }}
            >
              {filteredParametersData.length > 0 ? (
                <ParameterCustomAccordion
                  items={filteredParametersData}
                  onClickDeleteParameter={onClickDeleteParameter}
                  onClickDeleteRule={DeleteRuleOnClick}
                  onClickEditParameter={onClickEditParameter}
                />
              ) : (
                <span>
                  <Nodata />
                </span>
              )}
            </div>
          </div>
        </CardHeaderBG>
      </div>
      {deleteRuleModal && (
        <Modal
          open={deleteRuleModal}
          onClose={() => {
            setDeleteRuleModel(false);
          }}
          width={"35vw"}
        >
          <>
            <ModalHeader title={"Confirm Deletion"} content={<></>} />
            <div className="p-6 flex flex-col text-center fs-14 gap-4">
              <div className="flex justify-center">
                <img src={deleteicon} />
              </div>
              <div className="flex flex-col">
                <span> Are you sure you want to delete this Rule?</span>
                <span>This action cannot be undone.</span>
              </div>
            </div>
            <ModalFooter>
              <Button
                className="w-26"
                variant="gray"
                data-shape="round"
                onClick={() => {
                  setDeleteRuleModel(false);
                }}
              >
                Cancel
              </Button>
              <Button className="w-26" variant="danger" data-shape="round">
                Delete
              </Button>
            </ModalFooter>
          </>
        </Modal>
      )}
      {addParameterPanelStatus && (
        <PanelSlider
          direction={"right_to_left"}
          open={addParameterPanelStatus}
          onClose={() => {
            onClickAddParameter(false);
          }}
          style={{ width: "40vw" }}
        >
          <div
            //   ref={panelRef}
            onMouseDown={(e) => e.stopPropagation()}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="py-4 px-4 border-b flex items-center justify-between">
              <div>
                <h2 className="text-base font-semibold">
                  {addEditParameterMode == "EDIT"
                    ? "Edit"
                    : addEditParameterMode == "DELETE"
                    ? "Delete"
                    : "Add"}{" "}
                  Parameter
                </h2>
              </div>
              <div>
                <img
                  src={cancelIcon}
                  alt=""
                  className="cursor-pointer"
                  onClick={() => {
                    onClickAddParameter(false);
                  }}
                />
              </div>
            </div>
            <div className="">
              <AddParameter />
            </div>
          </div>
        </PanelSlider>
      )}
      {addRulePanelStatus && (
        <PanelSlider
          direction={"right_to_left"}
          open={addRulePanelStatus}
          onClose={() => {
            onClickAddRule(false);
          }}
          style={{ width: "40vw" }}
        >
          <div
            //   ref={panelRef}
            onMouseDown={(e) => e.stopPropagation()}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="py-4 px-4 border-b flex items-center justify-between">
              <div>
                <h2 className="text-base font-semibold">
                  {ruleMode === "edit"
                    ? "Edit Rule"
                    : ruleMode === "delete"
                    ? "Delete Rule"
                    : "Add Rule"}
                </h2>
              </div>
              <div>
                <img
                  src={cancelIcon}
                  alt=""
                  className="cursor-pointer"
                  onClick={() => {
                    onClickAddRule(false);
                  }}
                />
              </div>
            </div>
            <div>
              <div
                className="card_space_18 bg-gray-bg"
                style={{
                  height: "calc(100vh - 9rem)",
                }}
                id="scroll_style"
              >
                <AddRuleParams />
              </div>
              <div className="flex justify-between mt-4 px-2">
                <Button
                  variant="transparent"
                  onClick={() => {
                    onClickAddRule(false);
                  }}
                >
                  Cancel
                </Button>

                <div className="flex gap-2">
                  <Button
                    className=""
                    onClick={() => {
                      onAddRules();
                    }}
                    variant="contained"
                  >
                    Save Rule
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </PanelSlider>
      )}
    </>
  );
};
export default RiskEngine;
